export const bffApiURL = 'https://apim.wildfireapps-dev.alberta.ca';
export const returnURL = 'http://localhost:3000/dashboard';
export const bffURL = 'https://apim.wildfireapps-dev.alberta.ca';
//export const bffURL = 'https://localhost:7164';
